import { IFacebookOpenGraph } from '@components/shared/templates/DefaultTemplate/i-facebook-open-graph';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { IVendorVariantMedia } from '@models/VendorVariant/i-vendor-variant';

function createFacebookOpenGraph(
  media: IVendorVariantMedia[],
  retailPrice: number | undefined,
  salePrice: number | undefined,
  pageTitle: string,
  description: string | undefined,
  url: string,
) {
  let image = '';
  if (media.length > 0) image = media[0].uri;

  let price = retailPrice || '';
  if (salePrice) price = salePrice;

  const facebookOpenGraph: IFacebookOpenGraph = {
    site_name: 'Havenly',
    image,
    url,
    type: 'product',
    title: pageTitle,
    description: description || '',
    'price:amount': price.toString(),
    'price:currency': 'USD',
  };
  return facebookOpenGraph;
}

function trackSimilarProductClick(listId: string, similarProducts: any[], clickedProduct: any) {
  const listPosition = similarProducts.findIndex((product) => product.id === clickedProduct.id);
  analyticsTrack(
    'product_alternate_clicked',
    {
      listId,
      listPosition,
      productName: clickedProduct.title,
      vendorVariantId: clickedProduct.id,
    },
  );
}

export {
  createFacebookOpenGraph,
  trackSimilarProductClick
};
